// SPDX-License-Identifier: AGPL-3.0-or-later

export const VAULT_CODE_TEMP = 'YAPNET!TEMP';
export const VAULT_CODE_HIDDEN = 'YAPNET!HIDDEN';
export type VaultCode = typeof VAULT_CODE_TEMP | typeof VAULT_CODE_HIDDEN;

export const VAULT_ENVELOPE_PREFIX = 'YENC1.';

export const VAULT_PBKDF2_ITERATIONS = 300_000;
export const VAULT_SALT = 'yapnet-vault-salt-v1';

export const VAULT_VERIFIER_PLAINTEXT = 'yapnet-vault-verifier-v1';

export const VAULT_TEMP_INVITE_CONTENT = 'yapnet-temp-invite-v1';
export const VAULT_HIDDEN_INVITE_CONTENT = 'yapnet-hidden-invite-v1';

export interface VaultTtlOption {
	label: string;
	ms: number;
}

export const VAULT_TTL_OPTIONS: Array<VaultTtlOption> = [
	{label: 'Off', ms: 0},
	{label: '30s', ms: 30_000},
	{label: '5m', ms: 5 * 60_000},
	{label: '30m', ms: 30 * 60_000},
	{label: '1h', ms: 60 * 60_000},
];
export const VAULT_DEFAULT_TTL_MS = 0;

export interface VaultIdleOption {
	label: string;
	minutes: number;
}

export const VAULT_IDLE_OPTIONS: Array<VaultIdleOption> = [
	{label: 'Off', minutes: 0},
	{label: '15m', minutes: 15},
	{label: '30m', minutes: 30},
	{label: '1h', minutes: 60},
	{label: '6h', minutes: 360},
];
export const VAULT_DEFAULT_IDLE_MINUTES = 0;

export function normalizeVaultCode(content: string): VaultCode | null {
	const normalized = content.trim().toUpperCase();
	if (normalized === VAULT_CODE_TEMP) return VAULT_CODE_TEMP;
	if (normalized === VAULT_CODE_HIDDEN) return VAULT_CODE_HIDDEN;
	return null;
}
